import isObject from 'lodash/isObject'

export default {
	updateAlert ({ commit, getters }, [ alert, updated ]) {
		const index = isObject(alert) ? getters.findAlertIndex(alert) : alert
		if ( index <= -1 ) {
			return false;
		}

		alert = getters.getAlert(index)
		if ( ! alert || ! isObject(alert) || ! Object.keys(alert).length) {
			return false;
		}

		const updatedAlert = {...alert}
		Object.keys(updated).forEach(k => {
			updatedAlert[k] = updated[k]
		})

		commit('updateAlert', { index, alert: updatedAlert });
	},
}
